import { useAppDispatch, useAppSelector } from "../hooks/storeHooks";
import { logout, selectUser } from "../features/auth/authSlice";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import AccountCircle from "@mui/icons-material/AccountCircle";
import DarkModeToggle from "./DarkModeToggle";
import Grid2 from "@mui/material/Grid2";

const CustomMenu = ({ onLogout, onClosePopover }: { onLogout: () => void; onClosePopover: () => void }) => {
  const user = useAppSelector(selectUser);
  const navigate = useNavigate();

  const handleClickItem = (path: string) => {
    navigate(path);
    onClosePopover(); // Close the popover after navigating
  };

  return (
    <Card sx={{ minWidth: "16rem" }}>
      <Grid2
        container
        alignItems="center"
        spacing={1} // Adds some spacing between the items
      >
        {/* User Info */}
        <Grid2>
          <Box sx={{ p: 2, pb: 1.5 }}>
            <Typography variant="body2" noWrap>
              Welcome, {user?.first_name || user?.last_name ? `${user?.first_name} ${user?.last_name}` : `User`}.
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary" }} noWrap>
              {user?.email}
            </Typography>
          </Box>
        </Grid2>

        {/* Dark Mode Toggle Button */}
        <Grid2 sx={{ mr: 1 }}>
          <DarkModeToggle />
        </Grid2>
      </Grid2>
      <Divider sx={{ borderStyle: "dashed" }} />

      <MenuList
        disablePadding
        sx={{
          p: 1,
          gap: 0.5,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <MenuItem key={"profile"} onClick={() => handleClickItem("/userProfile")}>
          <AccountCircle />
          Profile
        </MenuItem>
      </MenuList>

      <Divider sx={{ borderStyle: "dashed" }} />

      <Box sx={{ p: 1 }}>
        <Button
          fullWidth
          color="error"
          size="medium"
          variant="text"
          onClick={() => {
            onLogout();
            onClosePopover(); // Close the popover after logout
          }}
        >
          Logout
        </Button>
      </Box>
    </Card>
  );
};

const AccountDropdown = ({ onClosePopover }: { onClosePopover: () => void }) => {
  const dispatch = useAppDispatch();

  const handleLogout = () => {
    dispatch(logout());
  };

  return (
    <>
      <CustomMenu onLogout={handleLogout} onClosePopover={onClosePopover} />
    </>
  );
};

export default AccountDropdown;
